// Mock data for Fiber Plast clone (bilingual it/en)
export const heroImage = 'https://images.unsplash.com/photo-1508108712903-49b7ef9b1df8?auto=format&fit=crop&w=2400&q=80';
export const forestImage = 'https://images.unsplash.com/photo-1476362555312-ab9e108a0b7e?auto=format&fit=crop&w=2400&q=80';
export const mountainsLayered = 'https://images.unsplash.com/photo-1552152370-fb05b25ff17d?auto=format&fit=crop&w=2400&q=80';

export const products = [
  {
    id: 'tubi-e-canali',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/4xt09jni_13%20DSC_0071%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/4xt09jni_13%20DSC_0071%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/1iwu6otu_06%20TUBI%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/vrjl5llx_16%20Immagine%20001%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/9n3n8tls_18%20Immagine%20006%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/pgb3apax_19%20Immagine%20051%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/66xp9g2h_01%20TEE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/x8air2k3_04%20RIDUZIONI%20FLANGIATE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/85aucj6l_05%20SPOOL%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/091sd7jt_12%20DSC_0059_WEB%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/gwyxuhcb_17%20Immagine%20005%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Tubazione e canali',
      subtitle: "L'energia della fibra di vetro",
      description:
        'FIBER PLAST produce tubazioni a partire dal DN 25 al DN 3000. Le lunghezze standard sono: per DN = 125 mt. 6 — per DN = 150 mt. 12. Siamo in grado di fornire lunghezze diverse in funzione delle esigenze del cliente.',
    },
    en: {
      title: 'Pipes and channels',
      subtitle: 'The power of fiberglass',
      description:
        'FIBER PLAST produces pipes from DN 25 up to DN 3000. Standard lengths are: 6 m for DN ≤ 125 and 12 m for DN ≥ 150. Custom lengths are available on request to match the customer\'s specifications.',
    },
    ar: {
      title: 'الأنابيب والقنوات',
      subtitle: 'قوة الألياف الزجاجية',
      description:
        'تُنتج FIBER PLAST أنابيب من DN 25 إلى DN 3000. الأطوال القياسية: 6 أمتار للـ DN ≤ 125 و12 متراً للـ DN ≥ 150. تتوفر أطوال مخصّصة عند الطلب لتلبية مواصفات العميل.',
    },
  },
  {
    id: 'installazioni',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/sry4xy76_01%20DSC_0063%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/sry4xy76_01%20DSC_0063%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/gio4zpql_02%20ENEL%20POWER%20AREZZO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/1g83z76p_03%20Foto%20Milazzo%20lavoro%20057%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/l6v2zlo2_04%20Foto%20Milazzo%20lavoro%20119%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/mra6hs8h_05%20MONTAGGIO%20TUBI%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Installazioni',
      subtitle: 'Montaggio e messa in opera',
      description:
        'FIBER PLAST realizza l\'installazione e la messa in opera di tubazioni, condotte e manufatti in vetroresina presso i cantieri dei clienti in Italia e all\'estero. Il nostro team qualificato garantisce montaggio, assistenza tecnica e collaudo secondo i più alti standard di sicurezza e qualità.',
    },
    en: {
      title: 'Installations',
      subtitle: 'Assembly and commissioning',
      description:
        'FIBER PLAST carries out on-site installation and commissioning of fiberglass pipes, ducts and components at customer sites in Italy and abroad. Our qualified team ensures assembly, technical assistance and testing to the highest safety and quality standards.',
    },
    ar: {
      title: 'التركيبات',
      subtitle: 'التجميع والتشغيل',
      description:
        'تتولّى FIBER PLAST التركيب والتشغيل في الموقع للأنابيب والقنوات والمكوّنات من الألياف الزجاجية لدى العملاء في إيطاليا والخارج. يضمن فريقنا المؤهّل التجميع والدعم الفني والاختبار وفق أعلى معايير السلامة والجودة.',
    },
  },
  {
    id: 'scrubber-e-torri-di-raffreddamento',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/ky9a3ol4_01%20DSC_0087%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/ky9a3ol4_01%20DSC_0087%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/1smwa178_02%20DSCN0173%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/mrmvmaai_03%20DSCN0179%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/m7v0vb00_04%20DSCN0189%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/72g5rfc6_05%20IMG_20181120_132506%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/az31k5h2_06%20IMG_20181127_161354%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/ofz8iuoy_07%20IMG_20190924_081657%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/2m5ckeip_08%20IMG-20210204-WA0008%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/vc5a3opn_09%20IMG-20210204-WA0009%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/ozjma6pv_10%20Immagine%20023%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Scrubber e torri di raffreddamento',
      subtitle: 'Filtrazione e raffreddamento',
      description:
        'FIBER PLAST è in grado di realizzare scrubber sino a 5.000 mm di diametro e sino a 19.000 mm di altezza, completi di tutti gli accessori.',
    },
    en: {
      title: 'Scrubbers and cooling towers',
      subtitle: 'Filtration and cooling',
      description:
        'FIBER PLAST manufactures scrubbers up to 5,000 mm in diameter and up to 19,000 mm in height, including all accessories.',
    },
    ar: {
      title: 'أبراج الغسل والتبريد',
      subtitle: 'الترشيح والتبريد',
      description:
        'تُصنّع FIBER PLAST أبراج غسل يصل قطرها إلى 5,000 مم وارتفاعها إلى 19,000 مم، مع جميع الملحقات.',
    },
  },
  {
    id: 'spray-bank',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6wt2v5hn_01%2011-12-2008%20029B%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6wt2v5hn_01%2011-12-2008%20029B%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/dbdwn9ny_02%2011-12-2008%20030B%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/045rch0z_04%20Foto%20Milazzo%20lavoro%20093%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/u368fznw_05%20Foto%20Milazzo%20lavoro%20114%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/lm5r3vpb_08%20Foto%20Milazzo%20lavoro%20125%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Spray Banks',
      subtitle: 'Lavaggio fumi',
      description:
        'FIBER PLAST s.r.l. produce una vasta gamma di spray banks per lavaggio fumi, da installare all’interno di assorbitori, sino ad un diametro di 25.000 mm.',
    },
    en: {
      title: 'Spray Banks',
      subtitle: 'Flue-gas washing',
      description:
        'FIBER PLAST s.r.l. produces a wide range of spray banks for flue-gas washing, to be installed inside absorbers, up to a diameter of 25,000 mm.',
    },
    ar: {
      title: 'مجموعات الرشّ (Spray Banks)',
      subtitle: 'غسل غازات المداخن',
      description:
        'تُنتج FIBER PLAST s.r.l. تشكيلة واسعة من مجموعات الرشّ لغسل غازات المداخن، تُركَّب داخل الماصّات وبأقطار تصل إلى 25,000 مم.',
    },
  },
  {
    id: 'skids',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/x7g9pssm_SKID%2001.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/x7g9pssm_SKID%2001.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/lmd0snq4_SKID%2002.jpeg',
    ],
    it: {
      title: 'Skids',
      subtitle: 'Impianti completi',
      description: 'FIBER PLAST fornisce parti di impianti o impianti completi su SKID, pronti per l’installazione in loco.',
    },
    en: {
      title: 'Skids',
      subtitle: 'Complete plants',
      description: 'FIBER PLAST supplies plant sections or complete plants on SKID, ready for on-site installation.',
    },
    ar: {
      title: 'الوحدات المُنزلقة (Skids)',
      subtitle: 'محطات متكاملة',
      description: 'تُوفّر FIBER PLAST أجزاء من المحطات أو محطات كاملة على قواعد SKID، جاهزة للتركيب في الموقع.',
    },
  },
  {
    id: 'serbatoi-e-vasche',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/4aphwwd8_00%20SERBATOI%20DN%205500%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/4aphwwd8_00%20SERBATOI%20DN%205500%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/hqttqh53_01%20SERBATOI%20IN%20STABILIMENTO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/63zqy65o_02%20SERBATOI%20PORTO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/0eqg3426_03%20A%20SERBATOIO%20RETTANGOLARE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/3kozvc0a_04%20SERBATOIO%20UREA%20HONG%20KONG%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/36k45tpz_05%20SERBATOI%20CON%20SCALE%20PASSERELLE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/04c2a3bp_06%20SERBATOIO%20ORIZZ.%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/7qmki2o0_07%20SERBATOIO%20ORIZZONTALE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/jsacad2c_08%20SERBATOI%20PIAZZALE%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/kzbe6ahc_09%20SERBATOI%20VARI%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/nbubf2el_11%20SERBATOI%20GIALLI%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/2i45f6lh_12%20SERBATOI%20DN%205000%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/9m61e9kn_13%20SERBATOIO%20DN%203000%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/jhnh114c_14%20SERBATOI%20VARI%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/yuzh441z_15%20INSTALLAZIONE%20SERBATOIO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/qrb98tq9_16%20SERBATOIO%20VERTICALE%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Serbatoi e Vasche',
      subtitle: 'Storage industriale',
      description:
        'FIBER PLAST è in grado di fornire una vasta gamma di serbatoi in vetroresina e/o in materiale termoplastico rinforzato (PVC; PP; PVDF; PVC-C), realizzati con la tecnologia del Filament Winding.',
    },
    en: {
      title: 'Tanks and vessels',
      subtitle: 'Industrial storage',
      description:
        'FIBER PLAST supplies a wide range of tanks in fiberglass and/or reinforced thermoplastic materials (PVC, PP, PVDF, PVC-C), manufactured with Filament Winding technology.',
    },
    ar: {
      title: 'الخزانات والأوعية',
      subtitle: 'التخزين الصناعي',
      description:
        'تُوفّر FIBER PLAST تشكيلة واسعة من الخزانات المصنوعة من الألياف الزجاجية أو من المواد الحرارية اللدنة المعزّزة (PVC، PP، PVDF، PVC-C)، بتقنية Filament Winding.',
    },
  },
  {
    id: 'reattori-mixer-e-sedimentatori',
    image: 'https://images.unsplash.com/photo-1513828646384-e4d8ec30d2bb?auto=format&fit=crop&w=1600&q=80',
    it: {
      title: 'Reattori, Mixer e Sedimentatori',
      subtitle: 'Processo chimico',
      description:
        'Realizziamo reattori, mixer e sedimentatori con la tecnologia del Filament Winding. Le dimensioni standard arrivano sino ai 5.000 mm di diametro; su richiesta si producono diametri superiori.',
    },
    en: {
      title: 'Reactors, Mixers and Settlers',
      subtitle: 'Chemical process',
      description:
        'We manufacture reactors, mixers and settlers with Filament Winding technology. Standard sizes reach up to 5,000 mm in diameter; larger diameters are available on request.',
    },
    ar: {
      title: 'المفاعلات والخلاطات والمُرَسِّبات',
      subtitle: 'العمليات الكيميائية',
      description:
        'نُصنّع المفاعلات والخلاطات والمُرَسِّبات بتقنية Filament Winding. الأحجام القياسية تصل إلى 5,000 مم قطراً؛ تتوفر أقطار أكبر عند الطلب.',
    },
  },
  {
    id: 'rivestimenti-e-camini',
    image: 'https://images.unsplash.com/photo-1693847173071-bd6237101335?auto=format&fit=crop&w=1600&q=80',
    it: {
      title: 'Rivestimenti e camini',
      subtitle: 'Anticorrosivi & antiacidi',
      description:
        'FIBER PLAST è specializzata nei rivestimenti anticorrosivi in ebanite e/o gomma e pavimentazioni antiacide, attività svolta da oltre 30 anni.',
    },
    en: {
      title: 'Linings and stacks',
      subtitle: 'Anti-corrosive & acid-proof',
      description:
        'FIBER PLAST specializes in anti-corrosive linings in ebonite and/or rubber and acid-proof flooring — activities carried out for more than 30 years.',
    },
    ar: {
      title: 'التبطينات والمداخن',
      subtitle: 'مقاومة التآكل والأحماض',
      description:
        'FIBER PLAST متخصّصة في التبطينات المضادّة للتآكل بالإيبونيت أو المطاط والأرضيات المقاومة للأحماض — نشاط تمارسه منذ أكثر من 30 عاماً.',
    },
  },
  {
    id: 'lavorazioni-speciali',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6s5qqrtz_EBANITATURA%20FILTRO%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6s5qqrtz_EBANITATURA%20FILTRO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/su2pcqoj_PEZZO%20VASCA%202%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/nylezlb0_PEZZO%20VASCA%20PORTOVESME%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Lavorazioni speciali',
      subtitle: 'Manufatti su misura',
      description:
        'FIBER PLAST realizza lavorazioni speciali su misura in vetroresina e materiali termoplastici rinforzati: canali, celle elettrolitiche, coperture, pezzi speciali e componenti custom progettati e prodotti secondo le esigenze del cliente.',
    },
    en: {
      title: 'Special manufacturing',
      subtitle: 'Custom components',
      description:
        'FIBER PLAST produces bespoke works in fiberglass and reinforced thermoplastics: channels, electrolytic cells, covers, special parts and custom components engineered and manufactured to meet the customer\'s exact requirements.',
    },
    ar: {
      title: 'الأعمال الخاصة',
      subtitle: 'مكوّنات مُخصّصة',
      description:
        'تُنفّذ FIBER PLAST أعمالاً خاصّة مُخصَّصة من الألياف الزجاجية والمواد الحرارية اللدنة المعزّزة: قنوات، خلايا كهربية، أغطية، قطع خاصّة ومكوّنات حسب الطلب، مُصمّمة ومُصنّعة لتلبية متطلبات العميل بدقّة.',
    },
  },
  {
    id: 'imballo-e-spedizioni',
    image: 'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6987ipd1_01%20PORTO%20-%20dimensioni%20medie.jpeg',
    gallery: [
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/6987ipd1_01%20PORTO%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/5mjynpwd_02%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/xs2za2i7_04%20DSC_0656%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/nqw28o75_05%20DSC_0657%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/coj968c3_06%20DSC_0660%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/xdwlp972_07%20G1%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/a3b8cl4z_08%20IMG_20180718_091934%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/c0ym99oc_09%20IMG_20180718_095423%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/n826oytt_10%20IMG_20181122_122155%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/bb0kwfto_11%20IMG_20200702_144409%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/sanrqou9_13%20IMG_20200703_113254%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/lvx6aics_14%20IMG_20201001_082300%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/qv5pi238_15%20IMG-20170516-WA0025%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/lz7j41n4_17%20IMG-20190925-WA0028%20-%20dimensioni%20medie.jpeg',
      'https://customer-assets.emergentagent.com/job_fiberplast-new/artifacts/ubfv5kzo_18%20Immagine%20029%20-%20dimensioni%20medie.jpeg',
    ],
    it: {
      title: 'Imballo e spedizioni',
      subtitle: 'Logistica in oltre 30 paesi',
      description:
        'FIBER PLAST cura l\'imballaggio e la spedizione dei manufatti in tutto il mondo, con soluzioni logistiche via terra, mare e aria. Grazie a un\'esperienza consolidata in oltre 30 paesi, garantiamo consegne sicure e conformi alle richieste del cliente.',
    },
    en: {
      title: 'Packaging and shipping',
      subtitle: 'Logistics in over 30 countries',
      description:
        'FIBER PLAST handles the packaging and shipping of its products worldwide, with logistic solutions by land, sea and air. Backed by proven experience in more than 30 countries, we guarantee safe deliveries fully compliant with customer requirements.',
    },
    ar: {
      title: 'التغليف والشحن',
      subtitle: 'الخدمات اللوجستية في أكثر من 30 دولة',
      description:
        'تتولّى FIBER PLAST تغليف وشحن منتجاتها حول العالم عبر حلول لوجستية برية وبحرية وجوية. بفضل خبرة موثّقة في أكثر من 30 دولة، نضمن عمليات تسليم آمنة وموافقة تماماً لمتطلبات العميل.',
    },
  },
];

export const servicesData = [
  {
    id: 'progettazione',
    image: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?auto=format&fit=crop&w=1200&q=80',
    it: { title: 'Progettazione e design', description: 'Progettiamo soluzioni tailor-made calibrate sulle specifiche esigenze tecniche del cliente.' },
    en: { title: 'Engineering and design', description: 'We design tailor-made solutions calibrated to each customer\'s specific technical requirements.' },
    ar: { title: 'الهندسة والتصميم', description: 'نُصمّم حلولاً مخصّصة تُلبّي المتطلبات الفنية الخاصة بكل عميل.' },
  },
  {
    id: 'imballaggi',
    image: 'https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80',
    it: { title: 'Imballaggi e trasporti', description: 'Gestione completa di imballaggi e logistica nel rispetto delle richieste cliente in oltre 30 paesi.' },
    en: { title: 'Packaging and shipping', description: 'End-to-end packaging and logistics management, respecting customer requirements in more than 30 countries.' },
    ar: { title: 'التغليف والنقل', description: 'إدارة شاملة للتغليف والخدمات اللوجستية وفق متطلبات العميل في أكثر من 30 دولة.' },
  },
  {
    id: 'installazione',
    image: 'https://images.unsplash.com/photo-1581094288338-2314dddb7ece?auto=format&fit=crop&w=1200&q=80',
    it: { title: 'Installazione e assistenza', description: 'Effettuiamo assistenza e montaggio in cantiere dei materiali forniti, con team qualificati.' },
    en: { title: 'Installation and support', description: 'We provide on-site assembly and after-sales support with qualified specialised teams.' },
    ar: { title: 'التركيب والدعم', description: 'نُقدّم خدمات التركيب في الموقع والدعم بعد البيع بواسطة فِرَق مؤهّلة ومتخصّصة.' },
  },
  {
    id: 'prefabbricazione',
    image: 'https://images.unsplash.com/photo-1565008447742-97f6f38c985c?auto=format&fit=crop&w=1200&q=80',
    it: { title: 'Prefabbricazione', description: 'Prefabbricazione in officina di componenti complessi per ridurre tempi e costi in cantiere.' },
    en: { title: 'Prefabrication', description: 'In-house prefabrication of complex components to cut on-site time and cost.' },
    ar: { title: 'التصنيع المسبق', description: 'تصنيع مسبق للمكوّنات المعقّدة في الورشة لتقليل وقت وتكلفة العمل في الموقع.' },
  },
];

export const companyInfo = {
  legal: 'FIBER PLAST SRL',
  legalAddress: 'PIAZZA DEL CARMINE 22 — 09124 CAGLIARI',
  opAddress: 'III STRADA CONSORTILE, ZI MACCHIAREDDU, CP 187. 09032 ASSEMINI (CA)',
  ksaLabel: 'KSA & MENA COMMERCIAL OFFICE',
  ksaAddress: 'Althumamah Rd. Alsaif Home Bldg. #16\nRiyadh\nSaudi Arabia',
  ksaPhone: '+966 55 713 8887',
  ksaEmail: 'ksa@fiberplast.biz',
  tel1: '+39 07024952300',
  tel2: '+39 07024952302',
  fax: '+39 070247357',
  piva: '01067950921',
  rea: '100449',
  capital: '100.000,00 €',
  email: 'info@fiberplast.it',
  facebook: 'https://www.facebook.com/fiberplastsrl/',
  linkedin: 'https://it.linkedin.com/company/fiber-plast-s.r.l.',
};
